export default __webpack_public_path__ + "static/media/Russiantournamettable_11zon.9e4eb2f9.webp";